import type { IntlShape } from 'react-intl';

import type { Validator } from '../../../types/field-validation';
import type { FormFieldValidation } from '../../../types/form/form-fields';
import type { FilesValue } from '../../../types/form/form-fields/field-values';
import { getFailedRequiredValidationError } from '../utils';

export const getAttachmentValidationErrors = (
	validation: FormFieldValidation,
	fieldLabel: string,
	intl?: IntlShape,
	filesValue?: FilesValue,
): ReturnType<Validator> => {
	if (Object.keys(validation).length === 0) {
		return [];
	}

	if (validation.required) {
		return !filesValue || !filesValue.files.length
			? [getFailedRequiredValidationError(fieldLabel, intl)]
			: [];
	}

	return [];
};
